import React from 'react';
import { Modal, Button } from 'grab-ui';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import cx from 'classnames';

import css from './expire-quote-modal.less';

const ExpireQuoteModal = ({ handleClose, visible }) => (
  <div className={cx(css.modalContainer, css.expireQuoteModalContainer)}>
    <Modal
      className={cx(css.modalContainer, css.expireQuoteModalContainer)}
      centered
      visible={visible}
      footer={[
        <div className={css.footerContainer} key="buttons">
          <div key="ok" className={cx(css.btnContainer)}>
            <Button
              type="primary"
              className={cx(css.cancelButton, css.keepButton, css.modalButton)}
              onClick={handleClose}
            >
              <span>
                {I18n.t('v2.anytimeBooking.quotes.modal.gotItButton')}
              </span>
            </Button>
          </div>
        </div>,
      ]}
      maskStyle={{ backgroundColor: 'rgba(28, 28, 28, 0.5)' }}
    >
      <div className={css.modalContainer}>
        <div className={css.infoContainer}>
          <h3>{I18n.t('v2.anytimeBooking.quotes.modal.priceHasUpdate')}</h3>

          <div>
            <span>
              {I18n.t('v2.anytimeBooking.quotes.modal.confirmToRefreshPrice')}
            </span>
          </div>
        </div>
      </div>
    </Modal>
  </div>
);

ExpireQuoteModal.propTypes = {
  handleClose: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
};
ExpireQuoteModal.defaultProps = {};

export default ExpireQuoteModal;
